import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Tabs, Button, Space, App, Pagination } from 'antd';
import { eventBus } from '@/utils/eventBus';
import YourTownloopOrdersListCar from '../../components/YourTownloopOrdersList/YourTownloopOrdersListCar';
import styles from './CarpoolService.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import { useTranslation } from 'react-i18next';
import { getOrderAllList, getOrderPageList, getOrderByKeyword } from '@/api/order';
import { getDriverCarpoolOrders, getCarpoolOrderBiddingList ,getDriverDeliveryOrders} from '@/api/car';

import { carpoolOrderStatusOptionsMapper } from '@/utils/constants';

import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';

// 接口返回的订单数据类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}



interface OrderListResponse {
  code: number;
  message: string;
  data: OrderItem[];
  total: number;
  totalPages: number;
  pageNum: number;
  pageSize: number;
}

// 转换后的订单类型


//tabItems切换 
const generateTabItems = (t:(key:string)=>string) => {
  const orderStatusOptions = carpoolOrderStatusOptionsMapper();
  const tabItems = [
    { label: t('common.All'), key: 'all' },
    ...orderStatusOptions.map(option => ({
      label: t('CarpoolService.'+option.label),
      key: option.value.toString()
    }))
  ];

  return tabItems;
};



// 订单状态映射 - 使用枚举
const getOrderStatusText = (status: number): string => {
  const orderStatusOptions = carpoolOrderStatusOptionsMapper();
  const statusOption = orderStatusOptions.find(option => option.value === status);
  return statusOption?.label || 'Unknown Status';
};

const CarpoolService: React.FC = () => {
  
  const { message } = App.useApp();
  const dispatch = useAppDispatch();
  // 国际化
  const { t } = useTranslation();
  const tabItems = generateTabItems(t);
  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  // 订单数据状态
  const [orders, setOrders] = useState<OrderItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0
  });

  //tab切换
  const [activeTab, setActiveTab] = useState('all');

  // 分类切换状态 - Emergency Service默认选中
  const [activeCategory, setActiveCategory] = useState<'ride' | 'delivery'>('ride');


   
 

  // 切换分类
  const handleCategoryChange = (category: 'ride' | 'delivery') => {
    setActiveCategory(category);

    setActiveTab('all');

    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0
    });
  };






  //切换tab事件
  const changeTab = (key: string) => {
    console.log('key', key);
    setActiveTab(key);
    // 切换tab时重新获取数据，传递order_status参数
    const orderStatus = key === 'all' ? undefined : parseInt(key);
    getOrderPageListData(1, pagination.pageSize, orderStatus);
  }

  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  const searchAction = () => {
    console.log('searchValue', searchValue);
    if (!searchValue.trim()) {
      // 如果搜索框为空，获取所有订单列表
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(1, pagination.pageSize, orderStatus);
      return;
    }

    // 通过关键字搜索订单
    // setLoading(true);
    // getOrderByKeyword(searchValue.trim()).then((res: any) => {
    //   if (res.code === 200 && res.data && res.data.length > 0) {
    //     // 搜索成功，将数据转换为订单格式
    //     const orderDataList = res.data.map((item: any) => ({
    //       order: {
    //         order_id: item.order_id,
    //         order_total_price: item.product_item_price,
    //         order_status: 0, // 默认状态
    //         order_payment_method: 'stripe',
    //         created_time: new Date().toISOString(),
    //       },
    //       orderItems: [item] // 将单个商品包装为订单项
    //     }));

    //     // 使用相同的数据转换函数
    //     // const transformedOrders = orderDataList.map(transformOrderData);
    //     setOrders(res.data);
    //     setPagination({
    //       current: 1,
    //       pageSize: 10,
    //       total: res.data.length,
    //       totalPages: Math.ceil(res.data.length / 10)
    //     });
    //     message.success('Search successful, found ' + res.data.length + ' products');
    //   } else {
    //     message.error('No related products found');
    //     // 搜索失败时清空列表
    //     setOrders([]);
    //     setPagination({
    //       current: 1,
    //       pageSize: 10,
    //       total: 0,
    //       totalPages: 0
    //     });
    //   }
    // }).catch((error) => {
    //   console.error('Search products failed:', error);
    //   message.error('Search failed, please try again');
    // }).finally(() => {
    //   setLoading(false);
    // });
  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }

  // 转换接口数据为组件需要的格式
  // const transformOrderData = (orderData: OrderData): any => {
    

  //   return {
  //     ...orderData
  //   };
  // };

  //获取商品id
  const [showServicePanel, setShowServicePanel] = useState(false);
  const [serviceOrder, setServiceOrder] = useState<OrderItem | null>(null);
  const [serviceStep, setServiceStep] = useState('select');

  const getId = (id: string, action: string) => {
    if (action === 'service') {
      const order = orders.find((o: OrderItem) => (o.carpool_order_id || o.delivery_order_id) === id);
      setServiceOrder(order || null);
      setShowServicePanel(true);
      return;
    }
    if (action === 'delete' || action === 'confirm') {
      debugger
      // 删除成功后重新获取列表数据
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(pagination.current, pagination.pageSize, orderStatus);
    } else if (action === 'details') {
      message.success('Jump to details: ' + id);

    } else if (action === 'refresh') {
      getOrderPageListData(1, 10, undefined);
      
    }
  }

  //分页change
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);
    // 分页时保持当前tab状态
    const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
    getOrderPageListData(page, pageSize, orderStatus);
  }


 



  //获取订单页列表
  const getOrderPageListData = (pageNum: number = 1, pageSize: number = 10, orderStatus?: number) => {
    setLoading(true);
    const params: any = { page_num: pageNum, page_size: pageSize };
    if (orderStatus !== undefined) {
      params.order_status = orderStatus;
    }

    let api = getDriverCarpoolOrders;

    if(activeCategory === 'delivery'){
      api = getDriverDeliveryOrders;
    }
    api(params).then((res: OrderListResponse) => {
      console.log(res, 'getOrderPageListData');
      if (res.code === 200) {
        // 转换数据格式
        // const transformedOrders = res.data.map(transformOrderData);
        setOrders(res.data);
        setPagination({
          current: res.pageNum,
          pageSize: res.pageSize,
          total: res.total,
          totalPages: res.totalPages
        });
      } else {
        message.error(res.message || 'Failed to get order list');
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error('Failed to get order list');
    }).finally(() => {
      setLoading(false);
    });
  }


   //mounted 和unmounted
   useEffect(() => {
    // 初始化获取拼车送人订单列表
    getOrderPageListData(1, 10, undefined);

    return () => {
      console.log('Component destroyed');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, [activeCategory]);



  return (
    <div className={styles['order-box']}> 
    
      {!showServicePanel && (
        <div className={styles['left-panel']}>

          <>
            {/* 这里区分送人订单还是送货订单 */}
            <div className={styles['category-switch-container']}>
              <div className={styles['category-switch']}>
                <div 
                  className={`${styles['category-tab']} ${activeCategory === 'ride' ? styles['active'] : ''}`}
                  onClick={() => handleCategoryChange('ride')}
                >
                  {t('CarpoolService.RideOrder')}
                </div>
                <div 
                  className={`${styles['category-tab']} ${activeCategory === 'delivery' ? styles['active'] : ''}`}
                  onClick={() => handleCategoryChange('delivery')}
                >
                  {t('CarpoolService.DeliveryOrder')}
                </div>
              </div>
            </div>
            {/* 这里区分送人订单还是送货订单 */}


            <Tabs
              className={styles['favorites-tabs']}
              items={tabItems}
              activeKey={activeTab}
              onChange={changeTab}
            />
            

            <div className={styles['search-btn-box']}>
              {/* <div className={styles['sidebar-search']}>
                <input
                  value={searchValue}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                  onKeyDown={searchHandleKeyDown}
                  type="text"
                  placeholder="Enter product information to search"
                />
                <img src={iocn2} alt="" onClick={searchAction} />
              </div> */}
              <Button className={styles['search-btn']} onClick={searchAction}>{t('common.Search')}</Button>
            </div>

            <YourTownloopOrdersListCar orders={orders} getId={getId} type={activeCategory} isPoster={false}/>
            <div className={styles['pagination-box']}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={paginationChange}
                showSizeChanger={false}
                showQuickJumper
                showTotal={(total, range) => `${t('common.Items')}：${range[0]}/${range[1]} ${t('common.Total')}：${total}`}
              />
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default CarpoolService; 